import React, { useState, useRef, useEffect } from "react";
import { Icon } from "@iconify/react";
import AOS from "aos";
import { LanguageSelectProps } from "../interface/language.interfac";

const LanguageSelect: React.FC<LanguageSelectProps> = ({
  languages,
  current,
  onChange,
}) => {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  // Init AOS
  useEffect(() => {
    AOS.init({ duration: 200, once: false });
  }, []);

  // Refresh AOS on dropdown toggle
  useEffect(() => {
    AOS.refresh();
  }, [open]);

  // Close on outside click
  useEffect(() => {
    function handleClickOutside(e: MouseEvent) {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        setOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="relative" ref={ref}>
      {/* Toggle Button */}
      <button
        type="button"
        aria-haspopup="true"
        aria-expanded={open}
        onClick={() => setOpen(!open)}
        className="flex cursor-pointer items-center gap-2 px-3 py-2 rounded-lg dark:text-white"
      >
        <Icon icon={current.flag} width={20} height={20} />
        <span className="capitalize text-sm font-medium">{current.label}</span>
        <Icon
          icon="mdi:chevron-down"
          width={20}
          height={20}
          className={`transition-transform ${open ? "rotate-180" : ""}`}
        />
      </button>

      {/* Dropdown */}
    {open && (
  <div
    id="language-select"
    data-aos="fade-down"
    className="fixed inset-0 flex justify-center items-start mt-30 z-50"
    onClick={() => setOpen(false)} // backdrop click closes
  >
    {/* Backdrop */}
    <div className="absolute inset-0 backdrop-blur-xl" />

    {/* Panel */}
    <div
      className="
        relative 
        w-full max-w-[90vw] sm:max-w-xl md:max-w-4xl lg:max-w-6xl xl:max-w-[82rem]
        max-h-[80vh] overflow-y-auto
        py-4 sm:py-6 px-3 
        rounded-2xl sm:rounded-3xl 
        bg-white text-darkmode shadow-lg
        grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-y-2
      "
      onClick={(e) => e.stopPropagation()} // prevent closing when clicking inside
    >
      {languages.map((lang) => (
        <button
          key={lang.code}
          onClick={() => {
            onChange(lang);
            setOpen(false);
          }}
          className="
            cursor-pointer duration-300 flex justify-start gap-4 items-center
            hover:bg-brand-50 hover:rounded-lg
            w-full py-3 px-4
          "
        >
          <span className="flex items-center gap-3">
            <Icon icon={lang.flag} width={24} height={24} />
            <span className="flex flex-col items-start leading-6 capitalize">
              {lang.label}
            </span>
          </span>

          {current.code === lang.code && (
            <Icon
              icon="mdi:check-circle"
              width={24}
              height={24}
              className="text-green-500"
            />
          )}
        </button>
      ))}
    </div>
  </div>
)}



    </div>
  );
};

export default LanguageSelect;
